var map = {
	"./auditory-1.png": 1851,
	"./auditory-2.png": 9765,
	"./auditory-3.png": 6771,
	"./author-of-article.png": 8230,
	"./digital-1.png": 508,
	"./digital-2.png": 7618,
	"./digital-3.png": 3477,
	"./gift.png": 8781,
	"./gift@2x.png": 8088,
	"./home-bg-mob.png": 9057,
	"./home-bg.png": 1127,
	"./home-bg@1920.png": 6899,
	"./home-bg__curtain-mob.png": 5100,
	"./home-bg__curtain.png": 9593,
	"./home-bg__curtain@1920.png": 9569,
	"./home-bg__mirror-mob.png": 6165,
	"./home-bg__mirror.png": 401,
	"./home-bg__mirror@1920.png": 1803,
	"./home-bg__table-mob.png": 418,
	"./home-bg__table.png": 7356,
	"./home-bg__table@1920.png": 234,
	"./kinesthetic-1.png": 6809,
	"./kinesthetic-2.png": 8440,
	"./kinesthetic-3.png": 7803,
	"./popit-bg.png": 4386,
	"./promo-bg-mobile.png": 6478,
	"./promo-bg.png": 6939,
	"./visual-1.png": 5348,
	"./visual-2.png": 1249,
	"./visual-3.png": 2079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4735;